module.exports = __webpack_public_path__ + "img/baocun.8e8780a9.png";